import Grid from '@mui/material/Grid';
import type { FunctionComponent, PropsWithChildren } from 'react';

type FooterProps = PropsWithChildren;

export const Footer: FunctionComponent<FooterProps> = ({ children }) => (
    <Grid
        component="footer"
        container={true}
        justifyContent="space-between"
        sx={{
            alignItems: 'center',
            backgroundColor: 'background.default',
            borderTop: '1px solid',
            borderTopColor: 'cardborder.main',
            flexWrap: 'nowrap',
            height: '56px',
            justifyContent: 'space-between',
            px: 4,
        }}
    >
        {children}
    </Grid>
);
